// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"roomList_wrapper__1-ROU","title":"roomList_title__29z7f","rooms":"roomList_rooms__1CMg2"};